import { render, staticRenderFns } from "./mallOrderList.vue?vue&type=template&id=621fa1fa&scoped=true&"
import script from "./mallOrderList.vue?vue&type=script&lang=js&"
export * from "./mallOrderList.vue?vue&type=script&lang=js&"
import style0 from "./mallOrderList.vue?vue&type=style&index=0&id=621fa1fa&prod&lang=less&scoped=true&"
import style1 from "./mallOrderList.vue?vue&type=style&index=1&id=621fa1fa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621fa1fa",
  null
  
)

export default component.exports